import React from 'react';

import { ColumnHeaderSortable } from '../../../DataTable/index.jsx';
import { CurrencyFigure } from '../../../Figure/index.jsx';

import Column from './base.jsx';


var columnOptions = {
  id: 'col-held-value',
  title: 'Held Value (USD)'
};


class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  get overlayText() {
    return 'Shows the total value of your holdings (Held Amount x Price)';
  }

  get rightAlign() {
    return true;
  }
}


class DetailColumn extends React.Component {
  render() {
    return (
      <td className="text-right">
       <CurrencyFigure
          amount={(this.props.row.heldValue)}
          formatter="medium"
          zeroIsBlank
        />
      </td>
    );
  }
}


class HeldValue extends Column {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  sortAscending(a, b) {
    if (a.heldValue < b.heldValue) {
      return -1;
    }
    if (a.heldValue > b.heldValue) {
      return 1;
    }
    return super.sortAscending(a, b);
  }

  sortDescending(a, b) {
    if (a.heldValue < b.heldValue) {
      return 1;
    }
    if (a.heldValue > b.heldValue) {
      return -1;
    }
    return super.sortDescending(a, b);
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default HeldValue;

